import SearchIcon from '@mui/icons-material/Search';
import { Grid } from '@mui/material';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { IMassMailingLogSearchFilterDTO } from 'wisestep-api';
import {
  WsListingLoader,
  WsPagination,
  SearchBar,
  WsButton,
  WsColors,
  WsTitleBanner,
} from 'wisestep-base';

import NoDataFoundCard from '../../../../../components/noDataFoundCard';
import { AppLayoutTheme } from '../../../../candidates/utils/CandidateHelper';
import useMassMailingLogSearch from '../../../hooks/useMassMailingLogSearch';
import { massMailingLogSearchDefaultQuery } from '../../../utils/vendorsHelper';
import BroadCastListTable from '../broadCastListTable';

const BroadCastListing = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const params = useParams();
  const [query, setQuery] = useState<IMassMailingLogSearchFilterDTO>(
    massMailingLogSearchDefaultQuery
  );
  const [pageNumber, setPageNumber] = useState<number>(1);
  query.massMailingGroupId = `${params.id}`;
  query.firstRecordsOnly = false;
  const [vendorList, totalCount] = useMassMailingLogSearch(query, setLoader);
  const methods = useForm();
  const pageChange = (event, value) => {
    const updatedQuery = { ...query };
    updatedQuery.page = value;
    setQuery(updatedQuery);
    setPageNumber(value + 1);
  };
  const search = () => {
    query.query = methods.watch('search');
    setQuery({ ...query });
  };
  const navigate = useNavigate();

  return (
    <FormProvider {...methods}>
      <Grid container spacing={1} xs={12}>
        <Grid item xs={12} pb={2}>
          <AppLayoutTheme>
            <WsTitleBanner
              title="BroadCast History"
              goBack={() => navigate('/vendors/broadcast-history')}
            />
          </AppLayoutTheme>
        </Grid>
        <Grid xs={12} item pb={1}>
          {vendorList && (
            <WsPagination
              count={Math.ceil(totalCount / 50)}
              onChange={pageChange}
              itemsPerPage={50}
              pageNumber={query.page}
              defaultPage={pageNumber}
              isPageCount={true}
              type="Vendors"
              totalCount={totalCount}
            />
          )}
        </Grid>
        <Grid item xs={12} container justifyContent="flex-end">
          <Grid
            item
            xs={6}
            borderRadius={2}
            p={1}
            container
            bgcolor={WsColors.White}
            alignItems="center"
            justifyContent="flex-end"
          >
            <Grid xs={10}>
              <SearchBar
                name="search"
                placeholder="Search by Email,Name,SubscriptionStatus and EmailiStatus"
              />
            </Grid>
            <WsButton
              variant="outlined"
              size="small"
              onClick={() => search()}
              startIcon={<SearchIcon />}
            >
              Search
            </WsButton>
          </Grid>
        </Grid>
        <Grid item xs={12} container>
          {vendorList && vendorList.length > 0 && !loader ? (
            <Grid xs={12} pb={1}>
              <BroadCastListTable data={vendorList} />
            </Grid>
          ) : loader ? (
            <Grid item xs={12}>
              <WsListingLoader />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <NoDataFoundCard text="No Vendors Found" />
            </Grid>
          )}
        </Grid>
        <Grid xs={12} item>
          <WsPagination
            count={Math.ceil(totalCount / 50)}
            onChange={pageChange}
            itemsPerPage={50}
            pageNumber={query.page}
            defaultPage={pageNumber}
            isPageCount={false}
            type="Vendors"
            totalCount={totalCount}
          />
        </Grid>
      </Grid>
    </FormProvider>
  );
};
export default BroadCastListing;
